import { UserBasedVenueSerializer } from "@app-contexts/dashboard/features/venues/data/types/user-venue";
import { useUserVenueSession } from "@shared/modules/venue/hooks/useUserVenueSession";
import { useModelService } from "@shared/services/api/hooks/useModelService";
import { UseQueryOptions } from "react-query";
import VenueBasedProductsRepository from "../repositories/VenueBasedProductsRepository";
import { VenueBasedProductRevenueSerializerType } from "../types";

const useVenueProductsService = ({
  options,
}: {
  options?: UseQueryOptions<UserBasedVenueSerializer>;
} = {}) => {
  const { data: currentVenue } = useUserVenueSession({ options });
  const venueId = currentVenue?.id;
  const repository = new VenueBasedProductsRepository({ venueId });

  const modelService = useModelService(repository);

  const useStatsRevenue = (
    productId: number,
    {
      options,
    }: {
      options?: UseQueryOptions<VenueBasedProductRevenueSerializerType[]>;
    } = {}
  ) => {
    return modelService.useGenericQuery<
      VenueBasedProductRevenueSerializerType[]
    >("statsRevenue", {
      injects: { productId },
      options,
    });
  };

  return {
    ...modelService,
    useStatsRevenue,
  };
};

export default useVenueProductsService;
